export default{
  goodsList:{
    breadcrumb:{
      home:"首页",
      all:"全部商品"
    },
    filter:{
      catgTit:"分类",
      brandTit:"品牌",
      button:{
        open:"更多",
        close:"收起"
      },
      noFilter:"不限"
    },
    sort:{
      default:"综合排序",
      price:"价格",
      count:"销量",
      update:"更新时间"
    },
    total:{
      head:"共",
      tail:"件相关商品"
    },
    Table:{
      productName:"商品信息",
      goToshop:"进店",
      firstSkuName:"商品规格",
      dayOutput:"日供应量",
      price:"商品单价",
      egotiable:"面议",
      reight:"运费洽谈",
      money:"元",
      opert:"操作"
    },
    Button:{
      getDetails:"查看详情",
      car:"加入进货单",
      soldOut:"已售罄"
    },
    Download:{
      end:'到底了'
    },
    Confirm:{
      title:"提示",
      content:"货品已加入进货单",
      confirmButtonText:"去结算",
      cancelButtonText:"继续购物"
    },
    
  }
  
}